import type { PlayerSummary } from "./PlayerSummary";
import type { ProfileCover } from "./ProfileCover";

// Герой обложки: выбранный; при `auto` — самый частый (сводка отдаёт героев по убыванию
// матчей), без истории — никого; `none` — без обложки.
export const coverHeroId = (
  cover: ProfileCover,
  heroes: PlayerSummary["heroes"],
): number | null => {
  if (cover.kind === "hero") {
    return cover.hero_id ?? null;
  }
  return cover.kind === "auto" ? (heroes[0]?.hero_id ?? null) : null;
};
